import { Modal } from 'antd'
import RoundyModalStyle from './RoundyModal.module.css'

const RoundyModal = ({ 
    title, content, isModalOpen, 
    handleOk, okText = "OK",
    handleCancel, cancelText = "CANCEL"
  }) => {
  return (
    <Modal 
      className={`${RoundyModalStyle["roundy-modal"]}`} 
      title={title} open={isModalOpen} 
      onOk={handleOk} okText={okText} 
      onCancel={handleCancel} cancelText={cancelText}
    >
      <p>{content}</p>

      <div className={`${RoundyModalStyle["roundy-container"]}`}>
        <img src="/roundy_up2.png" alt="Roundy" />
      </div>
    </Modal>
  )
}

export default RoundyModal